// Shared chart configuration constants used across admin dashboard pages.
// Defined at module scope so they are referentially stable and never trigger
// re-renders in recharts components.

export const CHART_TICK_SM = { fontSize: 11 };
export const CHART_TICK_MD = { fontSize: 12 };

export const BAR_RADIUS_SM = [3, 3, 0, 0];
export const BAR_RADIUS_MD = [4, 4, 0, 0];
export const BAR_RADIUS_LG = [10, 10, 0, 0];

export const CHART_COLORS = ['#7c3aed', '#22c55e', '#ec4899', '#06b6d4', '#f59e0b', '#10b981'];
